import 'dotenv/config';
import { z } from 'zod';

const componentRegistrySchema = z.object({
  name: z.string(),
  dependencies: z.array(z.string()).optional(),
  devDependencies: z.array(z.string()).optional(),
  registryDependencies: z.array(z.string()).optional(),
  files: z.string(),
  type: z.enum(['components:ui', 'components:hook']),
});

const componentRegistryWithContentSchema = componentRegistrySchema.extend({
  files: z.array(
    z.object({
      name: z.string(),
      content: z.string(),
    })
  ),
});

async function getComponentRegistries(componentNames: string[]) {
  try {
    const componentRegistryPaths = componentNames.map((name) =>
      new URL(
        `/registry/components/${name}.json`,
        process.env.BASE_URL
      ).toString()
    );
    const result = await fetchRegistries(componentRegistryPaths);

    return z.array(componentRegistryWithContentSchema).parse(result);
  } catch {
    throw new Error(`Failed to fetch tree from registry.`);
  }
}

async function fetchRegistries(paths: string[]) {
  try {
    const results = await Promise.all(
      paths.map(async (path) => {
        const response = await fetch(path);
        return await response.json();
      })
    );

    return results;
  } catch (error) {
    throw new Error(`Failed to fetch registry from ${process.env.BASE_URL}.`);
  }
}

export default getComponentRegistries;
